import { connect } from 'react-redux';
import Header from './Header';
import selectors from '../../rootSelectors';
import { showLogoutModal } from '../screen/screenActions';
import { ASSESSMENT_TYPE, MAZE } from '../../constants/measure';

export const mapStateToProps = state => ({
    showStars: selectors.getAssessmentType(state) === ASSESSMENT_TYPE.BM,
    playlistForRender: selectors.getPlaylistItemsForRender(state),
    isMazeLicensed: selectors.isMeasureLicensed(state, MAZE.MEASURE),
});

export const mapDispatchToProps = dispatch => ({
    showModal: () => {
        dispatch(showLogoutModal());
    },
});

const HeaderContainer = connect(mapStateToProps, mapDispatchToProps)(Header);

export default HeaderContainer;
